export enum GATEWAY_STREAMING_TYPE {
  CONTINUOUS = 'CONTINUOUS',
  NON_CONTINUOUS = 'NON_CONTINUOUS',
  UNKNOWN = 'UNKNOWN'
}
